import * as _ from 'lodash';
import { createReducer, on } from '@ngrx/store';
import { ActionCd } from '@xpo-ltl/sdk-common';
import { LinehaulSchedule } from '@xpo-ltl/sdk-linehaulpayform';
import { addScheduleAction, deleteScheduleAction, patchScheduleAction, updateScheduleAction } from './schedules.actions';
import { AppStateUtils } from '../app-state.utils';
import { tassign } from 'tassign';

export const initialState: LinehaulSchedule[] = [];

export const ActivitiesReducer = createReducer(
  initialState,
  on(addScheduleAction, (state, action) => {
    const newSchedule = _.cloneDeep(action.schedule) as LinehaulSchedule;
    newSchedule.listActionCd = ActionCd.ADD;
    return [...state, { ...newSchedule }];
  }),
  on(updateScheduleAction, (state, action) => {
    const scheduleIndex = AppStateUtils.findScheduleIndexInState(state, action.schSequenceNbr);
    if (scheduleIndex < 0) {
      throw new Error(`SCHEDULE '${action.schSequenceNbr}' NOT FOUND`);
    }

    _.forOwn(action.schedule, (value, key) => {
      _.set(state[scheduleIndex], key, value);
    });

    if (state[scheduleIndex].listActionCd !== ActionCd.ADD) {
      state[scheduleIndex].listActionCd = ActionCd.UPDATE;
    }
    return state;
  }),
  on(deleteScheduleAction, (state, action) => {
    const existing = AppStateUtils.findScheduleInState(state, action.schSequenceNbr) as LinehaulSchedule;
    if (existing) {
      if (existing.listActionCd === ActionCd.ADD) {
        // remove newly added activity from list
        _.pull(state, existing);
      } else {
        // mark exisiting activity as deleted
        existing.listActionCd = ActionCd.DELETE;
      }
      state = [...state];
      return state;
    } else {
      // Schedule didn't exist in this Payform, so nothing to do
      return state;
    }
  }),
  on(patchScheduleAction, (state, action) => {
    const scheduleIndex = AppStateUtils.findScheduleIndexInState(state, action.schSequenceNbr);
    if (scheduleIndex < 0) {
      throw new Error(`SCHEDULE '${action.schSequenceNbr}' NOT FOUND`);
    }

    state[scheduleIndex] = tassign(state[scheduleIndex], action.patchData);

    if (state[scheduleIndex].listActionCd !== ActionCd.ADD) {
      state[scheduleIndex].listActionCd = ActionCd.UPDATE;
    }

    return state;
  })
);
